export default "__VITE_ASSET__kitF8DCd__"